import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Price } from '@/types';
import { useQuery } from '@tanstack/react-query';

export const getPriceList = (promotion: string | null): Promise<Price[]> => {
  return axios.get('/api/v1/payments/price_lists', { params: { promotion } });
};

type QueryFnType = typeof getPriceList;

type usePriceListsOptions = {
  promotion: string | null;
  config?: QueryConfig<QueryFnType>;
};

export const usePriceLists = ({
  promotion,
  config = {},
}: usePriceListsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['payments/price_lists'],
    queryFn: () => getPriceList(promotion),
  });
};
